import React from 'react';
import spinner from '../../images/flat-pencil-loading.gif';

const Spinner = () => {
    return (
        <div className='loading'>
            <div className='loading-wrapper'>
                <img src={spinner} />
            </div>
        </div>
    );
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/views/components/spinner.js